/**
 * Viewport-relative bottom edge of the sticky site header, clamped at zero.
 *
 * Two places need this number and each had grown its own copy of the query and the clamp:
 * `NotificationProvider` pins its fixed drawer to it, and `useProductFilters` offsets facet
 * and paging scrolls by it.
 *
 * The clamp is load-bearing, not defensive tidiness. On routes where the header is not
 * sticky — the `nav-component--static` variant AB#63271 adds for SparkIt — its bottom goes
 * negative as soon as the page scrolls, and an unclamped value would drag the drawer or the
 * scroll target off-screen. AB#63280
 */
export const measureNavBottom = (): number => {
  if (typeof document === 'undefined') {
    return 0
  }
  const nav = document.querySelector('.nav-component') as HTMLElement | null
  return nav ? Math.max(0, nav.getBoundingClientRect().bottom) : 0
}
